import { LEAD_STATUSES, statusMeta, type LeadStatus } from '@delvero/contracts';
import { Icon } from './Icon';

export function StatusBadge({ status }: { status: LeadStatus }) {
  const s = statusMeta(status);
  return (
    <span className="badge" style={{ color: s.color, background: `${s.color}14`, borderColor: `${s.color}33` }}>
      <span className="dot" style={{ background: s.color }} />
      {s.label}
    </span>
  );
}

export function StatusSelect({ value, onChange }: { value: LeadStatus; onChange: (v: LeadStatus) => void }) {
  const s = statusMeta(value);
  return (
    <span
      className="status-sel"
      style={{ color: s.color, background: `${s.color}12`, borderColor: `${s.color}33` }}
      onClick={(e) => e.stopPropagation()}
    >
      <span className="dot" style={{ background: s.color }} />
      <span className="status-sel-label">{s.label}</span>
      <select value={value} onChange={(e) => onChange(e.target.value as LeadStatus)} aria-label="Status">
        {LEAD_STATUSES.map((st) => (
          <option key={st.id} value={st.id}>
            {st.label}
          </option>
        ))}
      </select>
      <Icon name="chev" size={11} />
    </span>
  );
}
